module.exports = __webpack_public_path__ + "static/img/visible.8c465757.png";